//
//  src/components/enquire/Enquire.js
//
import * as React        from 'react';
import { Routes, Route } from 'react-router-dom';
import EnquireForm  from './EnquireForm';
import FormSent  from '../../layouts/default/contact/form/sent/Sent';
import FormError    from '../../layouts/default/contact/form/error/Error';
import './Enquire.css'


//
//  enquire
//
export default function Enquire(props) {

     return (
          <div className="container enquire">
               <Routes>
                    <Route path=""         element={<EnquireForm  />} />
                    <Route path="error/"   element={<FormError    />} />
                    <Route path="sent/"   element={<FormSent  />} />
               </Routes>
          </div>
     );

}
